import Vue from 'vue'
import Vuex from 'vuex'
import Moment from 'moment'

const fb = require('./firebase')

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    activeGroup: 'TXOSAetRGy7ZpqV4gn51',
    activeUser: '',
    posts: {},
    groups: {},
    users: {},
    comments: {},
    latestPosts: [],
    // snack-bar / Toast
    snackBar: false,
    snackColor: 'info',
    snackText: 'hello',
    snackMultiLine: false,
    snackTimeout: 5000
  },
  getters: {
    getLatestPosts (state) {
      return state.latestPosts
    },
    getActiveGroup (state) {
      return state.activeGroup
    },
    getActiveUser (state) {
      return state.activeUser
    },
    getPostById: (state) => (id) => {
      return state.posts[id]
    },
    getComments (state) {
      return state.comments
    }
  },
  mutations: {
    setActiveGroup (state, val) {
      state.activeGroup = val
    },
    setActiveUser (state, val) {
      state.activeUser = val
    },
    showSnack (state, val) {
      state.snackText = val
      state.snackBar = true
    },
    updatePosts (state, val) {
      // console.log('updatePosts', val)
      // state.posts[val[0]] = val[1]
      val[1].id = val[0]
      Vue.set(state.posts, val[0], val[1])
      // state.posts.splice(val[0], 1, val[1])
    },
    updateGroups (state, val) {
      // console.log('updateGroups', val)
      // state.groups.splice(val[0], 1, val[1])
      val[1].id = val[0]
      Vue.set(state.groups, val[0], val[1])
    },
    updateUsers (state, val) {
      // console.log('updateUsers', val)
      // state.users.splice(val[0], 1, val[1])
      val[1].id = val[0]
      Vue.set(state.users, val[0], val[1])
    },
    updateComments (state, val) {
      // console.log('updateComments', val)
      // state.comments.splice(val[0], 1, val[1])
      if (val[1] !== undefined) {
        val[1].id = val[0]
        Vue.set(state.comments, val[0], val[1])
      }
    },
    addLatestPosts (state, val) {
      state.latestPosts.push(val)
    }
  },
  actions: {
    fetchAll ({commit}) {
      // console.log('fetchAll')
      let groups = {}
      let users = {}
      let posts = {}
      let comments = {}
      fb.groupsCollection
        .where('users', 'array-contains', fb.usersCollection.doc(fb.auth.currentUser.uid))
        .onSnapshot(function (snapGroups) {
          snapGroups.forEach((group) => {
            // console.log('groupsCollection snapshot', group.id, group.data())
            groups[group.id] = group.data()
            commit('updateGroups', [group.id, group.data()])

            fb.postsCollection
              .where('group', '==', fb.groupsCollection.doc(group.id))
              .orderBy('created', 'desc')
              .where('created', '>', new Date(Moment().subtract(7, 'days')))
              .onSnapshot(function (snapPosts) {
                // console.log('postsCollection snapshot', snapPosts)

                snapPosts.forEach((post) => {
                  posts[post.id] = post.data()

                  if (posts[post.id].comments === undefined) {
                    posts[post.id].comments = []
                  }

                  commit('updatePosts', [post.id, post.data()])
                  let postComments = posts[post.id].comments
                  postComments.forEach((commentRef) => {
                    fb.commentsCollection.doc(commentRef.id)
                      .get()
                      .then((commentDoc) => {
                        comments[commentDoc.id] = commentDoc.data()
                        commit('updateComments', [commentDoc.id, commentDoc.data()])
                      })
                  })
                })
              })

            let groupUsers = groups[group.id].users
            groupUsers.forEach((groupUser) => {
              fb.usersCollection
                .doc(groupUser.id)
                .get()
                .then((user) => {
                  users[user.id] = user.data()
                  commit('updateUsers', [user.id, user.data()])
                })
            })
          })
        })
    },
    addComment ({commit, state}, val) {
      // val[0] = caption, val[1] = postId
      // console.log('addComment val[0]', val[0])
      // console.log('addComment val[1]', val[1])

      if (val[0] !== '') {
        let newComment = {
          caption: val[0],
          created: new Date(),
          user: fb.usersCollection.doc(fb.auth.currentUser.uid)
        }

        fb.commentsCollection.add(newComment)
          .then(function (comment) {
            let comments = state.posts[val[1]].comments

            if (comments === undefined) { comments = [] }
            comments.push(fb.commentsCollection.doc(comment.id))

            newComment.created = {
              seconds: Math.round((new Date()).getTime() / 1000)
            }
            commit('updateComments', [comment.id, newComment])
            // state.comments[comment.id] = newComment

            fb.postsCollection.doc(val[1]).set({
              comments: comments
            }, { merge: true })
              .then(() => {
              })
          })
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js